import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlusCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12,24A12,12,0,1,0,0,12,12,12,0,0,0,12,24ZM6,11h4.75a.25.25,0,0,0,.25-.25V6a1,1,0,0,1,2,0v4.75a.25.25,0,0,0,.25.25H18a1,1,0,0,1,0,2H13.25a.25.25,0,0,0-.25.25V18a1,1,0,0,1-2,0V13.25a.25.25,0,0,0-.25-.25H6a1,1,0,0,1,0-2Z",
		fill: "currentColor"
	})
});
export { SvgPlusCircle as ReactComponent };
